/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ViridisChem API
 * API documentation for ViridisChem API
 */

/**
 * Current phase of an SDS build.
 */
export type SdsBuildPhase = (typeof SdsBuildPhase)[keyof typeof SdsBuildPhase];

export const SdsBuildPhase = {
    /** Validate the request and selected SDS profile. */
    VALIDATING: "VALIDATING",
    /** Resolve the supplied chemical identifiers. */
    RESOLVING_CHEMICALS: "RESOLVING_CHEMICALS",
    /** Load available chemical and regulatory data. */
    LOADING_DATA: "LOADING_DATA",
    /** Estimate missing chemical properties when the operation permits estimation. */
    ESTIMATING_PROPERTIES: "ESTIMATING_PROPERTIES",
    /** Calculate mixture properties and classifications. */
    CALCULATING_MIXTURE: "CALCULATING_MIXTURE",
    /** Generate and validate the localized SDS document or documents. */
    GENERATING_DOCUMENT: "GENERATING_DOCUMENT",
    /** The SDS build has completed successfully. */
    COMPLETE: "COMPLETE",
} as const;
